// React
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, NavLink } from 'react-router-dom';
import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { breadcrumbsActions } from '@store/breadcrumbs';
import { CONFIG_MODULE_LIST } from '../../legacy-payment-options.constants';
import {
  LEGACY_CONFIGURATION_MODULE_LIST_ROUTE,
  viewConfigurationModule,
} from '../../legacy-payment-options.breadcrumbs';

const ItemWrapper = styled(NavLink)`
  display: flex;
  box-shadow: 4px 4px 8px #d9d9d9;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
  margin: 10px;
  min-height: 120px;
  color: #374151;
  cursor: pointer;
  text-decoration: none;
  height: calc(100% - 20px);

  [class~='title'] {
    word-wrap: break-word;
    word-break: break-word;
    font-weight: 400;
  }

  &:hover {
    font-weight: 500;
    background-color: #e94334;
    color: white;
    box-shadow: 4px 4px 8px #847777;
    border: none;
  }

  [class~='MuiTypography-h6'] {
    font-size: 18px;
  }

  [class~='MuiTypography-subtitle1'] {
    font-size: 11px;
  }
`;

function PaymentMerchantsTiled({ permissions }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [data, setData] = useState([]);

  useEffect(() => {
    dispatch(breadcrumbsActions.showMenu(true));
    dispatch(breadcrumbsActions.setBreadcrumbs(viewConfigurationModule));
  }, [dispatch]);

  useEffect(() => {
    setData(CONFIG_MODULE_LIST);
  }, []);

  // Authorization
  useEffect(() => {
    if (!permissions?.canViewConfigModule) {
      navigate('/landing');
    }
  }, [navigate, permissions]);

  return (
    <Grid
      container
      spacing={2}
      justifyContent="flex-start">
      {data.map((lob) => (
        <Grid
          onClick={() => {
            const env = process.env.NODE_ENV;
            const path = env === 'production' ? lob.prdPath : lob.stgPath;
            navigate(`${LEGACY_CONFIGURATION_MODULE_LIST_ROUTE}/${path}`);
          }}
          item
          key={lob.name}
          xs={4}
          md={2}
          textAlign="center">
          <ItemWrapper>
            <Typography
              className="title"
              gutterBottom
              component="div">
              {lob.name}
            </Typography>
          </ItemWrapper>
        </Grid>
      ))}
    </Grid>
  );
}

export default PaymentMerchantsTiled;
